<div
  class="account-balances-container"
  [class.account-balances-container-wide]="isFullWidth"
  [class.no-bottom-offset]="noBottomOffset"
  [class.account-balances-container-vertical]="isVerticalOrientation"
>
  <div class="flex justify-between items-center">
    <div class="text-base/7 text-black font-bold">{{ label }}</div>
  </div>

  <div class="flex flex-wrap">
    <div class="balance-items">
      @for (item of accountBalances; track $index) {
        <ng-container
          *ngTemplateOutlet="
            balanceItem;
            context: { $implicit: item, value: $safeNavigationMigration(accountBalanceValues?.[item.type]), isLoading }
          "
        ></ng-container>
      }
    </div>

    <div class="balance-items balance-pending-items">
      @for (item of pendingBalances; track $index) {
        <ng-container
          *ngTemplateOutlet="
            balanceItem;
            context: {
              $implicit: item,
              value: $safeNavigationMigration(accountBalanceValues?.[item.type]),
              isLoading,
              isPendingBalance: true,
            }
          "
        ></ng-container>
      }
    </div>
  </div>
</div>

<ng-template #balanceItem let-item let-value="value" let-isLoading="isLoading" let-isPendingBalance="isPendingBalance">
  <div class="account-balances-item" [class.primary]="item.isPrimary" [class.loading]="isLoading">
    @if (isLoading) {
      <div class="label">
        <div class="loading-placeholder" [class.dark-bg]="isPendingBalance"></div>
      </div>

      <div class="value">
        <div class="loading-placeholder" [class.dark-bg]="isPendingBalance"></div>
      </div>
    } @else {
      <div class="label">
        {{ item.label }}

        <div class="label-tooltip"><rkt-icon name="info" [title]="item.tooltip"></rkt-icon></div>
      </div>

      @if (available) {
        <div class="value">
          @if (item.icon) {
            <span class="value-icon" [ngClass]="'value-icon-' + item.icon"></span>
          }
          <div class="account-balance">
            {{ (value ? (isPendingBalance ? (value | abs) : value) : '0.00') | currency: selectedCurrency : 'symbol-narrow' }}
          </div>
        </div>
      } @else {
        <div class="value not-available">N/A</div>
      }
    }
  </div>
</ng-template>
